import { Weekday } from './types/weekday';

export const isMagnoliaEditingMode = (): boolean => window.ui?.cmsState?.mode === 'editing';

export const isMagnoliaPreviewMode = (): boolean => window.ui?.cmsState?.mode === 'preview';

export const isMagnoliaAuthoringMode = (): boolean => isMagnoliaEditingMode() || isMagnoliaPreviewMode();

export const getDocumentHeight = () => {
  const { body } = document;

  const html = document.documentElement;

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
};

export const getLocaleTime = (
  timestamp: string,
  locale: string = document.documentElement.lang || 'de-DE',
  timeZone = 'UTC'
) => {
  const localeTimeString = new Date(timestamp).toLocaleTimeString(locale, {
    timeStyle: 'short',
    timeZone,
  });
  const suffix = locale.startsWith('de') ? 'Uhr' : '';
  return `${localeTimeString} ${suffix}`;
};

export const getLocaleTimeWithSuffix = (time: string, locale: string = document.documentElement.lang || 'de-DE') => {
  const suffix = locale.startsWith('de') ? 'Uhr' : '';
  return `${time} ${suffix}`.trim();
};

export const getFromDay = (weekday: Weekday) => `from${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;

export const getToDay = (weekday: Weekday) => `to${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;

export const formatDate = (date: string | Date, locale: string = document.documentElement.lang || 'de-DE'): string => {
  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
